/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1621
 */

"use strict"

var r = require(/* 86 */"../1650/86/index")
var o = require(/* 194 */"../1648/194")
var i = require(/* 1255 */"./1255/index")
var a = require(/* 759 */"../1707/759")
var /* [auto-meaningful-name] */i$ArrayBuffer = i.ArrayBuffer
r({
  global: true,
  forced: o.ArrayBuffer !== i$ArrayBuffer
}, {
  ArrayBuffer: i$ArrayBuffer
})
a("ArrayBuffer")
